module.exports = __webpack_public_path__ + "media/site/images/products/actionplan-flat-screen6@2x-dcc2698966a738a1a70a94a817ee6edd.png";